module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "left",
      "label-width": "180px"
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否开启积分："
    }
  }, [_c('el-switch', {
    attrs: {
      "width": 60,
      "active-value": "true",
      "inactive-value": "false",
      "inactive-color": "#ccc",
      "active-text": "开启",
      "inactive-text": "关闭",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.isOpenMemberPoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "isOpenMemberPoint", $$v)
      },
      expression: "form.isOpenMemberPoint"
    }
  })], 1), _vm._v(" "), (_vm.form.isOpenMemberPoint == 'true') ? [_c('el-form-item', {
    attrs: {
      "label": "积分获取比例："
    }
  }, [_vm._v("\n                  订单金额1元人民币 获得"), _c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "number",
      "placeholder": "",
      "min": 1,
      "max": 9999999
    },
    model: {
      value: (_vm.form.gain_point),
      callback: function($$v) {
        _vm.$set(_vm.form, "gain_point", $$v)
      },
      expression: "form.gain_point"
    }
  }), _vm._v("积分\n              ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "积分获取限制："
    }
  }, [_vm._v("\n                  每月最多获取"), _c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "number",
      "placeholder": "",
      "min": 1,
      "max": 9999999
    },
    model: {
      value: (_vm.form.gain_limit),
      callback: function($$v) {
        _vm.$set(_vm.form, "gain_limit", $$v)
      },
      expression: "form.gain_limit"
    }
  }), _vm._v("积分\n                  "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("不限制请填写999999")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "积分获取时间："
    }
  }, [_vm._v("\n                 订单完成"), _c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "number",
      "placeholder": "",
      "min": 1,
      "max": 9999999
    },
    model: {
      value: (_vm.form.gain_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "gain_time", $$v)
      },
      expression: "form.gain_time"
    }
  }), _vm._v("天，获取积分\n              ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否开启积分抵扣："
    }
  }, [_c('el-switch', {
    attrs: {
      "width": 60,
      "active-value": "true",
      "inactive-value": "false",
      "inactive-color": "#ccc",
      "active-text": "开启",
      "inactive-text": "关闭",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.isOpenDeductPoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "isOpenDeductPoint", $$v)
      },
      expression: "form.isOpenDeductPoint"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "积分抵扣比例："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "number",
      "placeholder": "",
      "min": 1,
      "max": 9999999
    },
    model: {
      value: (_vm.form.deduct_point),
      callback: function($$v) {
        _vm.$set(_vm.form, "deduct_point", $$v)
      },
      expression: "form.deduct_point"
    }
  }), _vm._v("积分 抵扣1元人民币\n              ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "积分抵扣使用限制："
    }
  }, [_vm._v("\n                 每月最多抵扣使用"), _c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "number",
      "value": "0",
      "min": 0,
      "max": 9999999
    },
    model: {
      value: (_vm.form.deduct_limit),
      callback: function($$v) {
        _vm.$set(_vm.form, "deduct_limit", $$v)
      },
      expression: "form.deduct_limit"
    }
  }), _vm._v("积分\n                 "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("不限制请填写999999")])], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保 存")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header with-border"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("积分配置")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8c3536de", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c3536de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/point/index.vue
// module id = 2876
// module chunks = 0